import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CargoCaseNews').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '90%',
    overflow: 'hidden',
    height: '120px',
    borderRadius: '12px',
    boxShadow: '2px 0px 10px 0px rgba(0, 0, 0, 0.20)',
    backgroundColor: 'black',

    h1: {
      textAlign: 'center',
      fontFamily: 'Inter',
      fontSize: '34px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '80%',
      margin: '0px',
      letterSpacing: '-0.68px',
    },

    h2: {
      textAlign: 'center',
      fontFamily: 'Inter',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: '550',
      lineHeight: '100%',
      margin: '0px',
      letterSpacing: '-0.18px',
    },
  },

  arrivalContainer: {
    height: '32px',
    borderRadius: '24px',
    boxShadow: '0px 0px 10px 3px #2990FF',
    background: 'linear-gradient(180deg, #5EBEF0 0%, #0395FD 100%)',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',

    color: theme.colors.text.primary,
    textAlign: 'center',
    padding: '2px',
    textShadow: '0px 0px 10px #2990FF',
    fontSize: '14px',
    fontWeight: '450',
    lineHeight: '18px',
    letterSpacing: '-0.13px',
  },

  textWrapper: {
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '121px',
    top: '10%',
    left: '24px',
    position: 'absolute',
  },

  cargoImg: {
    position: 'absolute',
    width: '204px',
    right: '0px',
    top: '-48px',
  },

  frontTokensImg: {
    position: 'absolute',
    right: '-20px',
    top: '72px',
    width: '240px',
  },

  backTokensImg: {
    position: 'absolute',
    right: '72px',
    top: '64px',
    width: '160px',
    filter: 'blur(1px)',
  },
}))
